
const m = window.require("@uppy/aws-s3-multipart");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
